import {v4} from "uuid"

export const uuid  = ()=>{

    return v4().replaceAll("-","")
}